import { setLoading, setFinished } from './LoadingButton'

export default () => {
  const forms = document.querySelectorAll('.js-login-form')
  if (forms.length < 1) return // For each form...
  ;[...forms].forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault()

      // Set button to loading
      const button = form.querySelector('.c-button')
      setLoading(button)

      // Stop here if form isn't valid
      if (!form.checkValidity()) return

      setTimeout(() => {
        setFinished(button)
        form.submit()
      }, 1000)
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/SendLoginForm.js